import React from 'react';
import { IoPeopleSharp } from "react-icons/io5";
import { GoGraph } from "react-icons/go";
import { IoMdMail } from "react-icons/io";
import { FaArrowRight, FaBuffer } from "react-icons/fa";
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer';
import Wtbox from './whychoosecomponent/Wtbox';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const WhyChoose = () => {
    const location = useLocation();
    console.log("locationWhyChoose", location?.pathname);
    return (
        <>
            <Helmet>
                <title>Why Choose iLine Logistics | Best Logistics app in Delhi-NCR</title>
                <meta name="description" content="Discover why iLine.AI Logistics app is the top choice for logistics services in Delhi. We offer reliable delivery, exceptional customer service, and tailored logistics solutions to meet your unique needs" />
                <link rel="canonical" href={`https://iline.ai${location.pathname}`} />
            </Helmet>
            <Header />
            <section className="WhyChooseUs">
                <div className="container">
                    <div className="wwaLeft">
                        <h2>
                            Why Choose <br /> Us?
                        </h2>
                    </div>
                    <div className="wwaRight">
                        <p>
                            At Iline, we are redefining logistics with a focus on sustainability, efficiency, and innovation. Our electric vehicle (EV)-powered logistics solutions are designed to meet the evolving needs of businesses while contributing to a greener future.
                        </p>
                    </div>
                </div>
            </section>
            {/* <section className="WhyServices">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                        <div className="wwaLeft">
                        <h3>Why Logi Services?</h3>
                        <p className="paragraph">
                            Our mission statement is simplicity itself. To constantly exceed
                            customer expectations by providing superior freight forwarding and
                            global transportation solutions including air, ocean, and customs
                            brokerage and logistics services.
                        </p>
                    </div>
                        </div>
                        <div className="col-lg-6">
                        <div className="wwaRight">
                        <p>
                            Our team of professionals is totally committed to provide you a
                            service that far exceeds your expectations. We put forward a
                            tremendous extra effort everyday to give this level and quality of
                            service and we are always striving to deliver the most efficient
                            and effective solutions in the industry by utilizing state of the
                            art technologies, highly trained friendly and experience staff as
                            well as a solid infrastructure.{" "}
                        </p>
                    </div>
                        </div>
                    </div>
                    
                    
                </div>
            </section> */}
            <section className='base-container mt-5'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div class="info-card" data-aos="fade-up" data-aos-delay="300">
                                <a href="#" class="icon-text">
                                    <IoPeopleSharp />
                                </a>

                                <h3>Unbeatable Savings with EV Shipping</h3>
                                <p class="paragraph">
                                    <strong>Lower Costs:</strong> Say goodbye to high fuel expenses and excessive maintenance charges. Our EV logistics model ensures cost-effective deliveries for your business.
                                </p>
                                <p class="paragraph">
                                    <strong>Affordable Rates:</strong> We offer competitive pricing without sacrificing quality, helping you maximize your budget.
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div class="info-card" data-aos="fade-up" data-aos-delay="400">
                                <a href="#" class="icon-text">
                                    <GoGraph />
                                </a>
                                <h3>Eco-Friendly Transportation</h3>
                                <p class="paragraph">
                                    <strong>Zero Emissions:</strong> By choosing I-Line, you contribute to a greener planet by eliminating CO₂ and harmful gas emissions with every delivery.
                                </p>
                                <p class="paragraph">
                                    <strong>Real-Time Carbon Tracking:</strong> Monitor and showcase the positive environmental impact of your shipments to align with sustainability goals.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div class="info-card" data-aos="fade-up" data-aos-delay="500">
                                <a href="#" class="icon-text">
                                    <IoMdMail />
                                </a>
                                <h3>Efficiency Meets Innovation</h3>
                                <p class="paragraph">
                                    <strong>Advanced AI Technology:</strong> Depend on precision and punctuality with our state-of-the-art electric fleet.
                                </p>
                                <p class="paragraph">
                                    <strong>Smart Routing:</strong> Experience faster, more energy-efficient deliveries with optimized routing, reducing delays and costs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='base-container'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div class="info-card" data-aos="fade-up" data-aos-delay="300">
                                <a href="#" class="icon-text">
                                    <IoPeopleSharp />
                                </a>

                                <h3>Enhanced Earnings Potential</h3>
                                <p class="paragraph">
                                    <strong>Lower Operating Costs:</strong> Benefit from EVs' low maintenance requirements and fuel-free operation, ensuring higher profitability.
                                </p>
                                <p class="paragraph">
                                    <strong>Optimized Utilization:</strong> Advanced AI tools maximize fleet efficiency, ensuring your vehicles are always in demand.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div class="info-card" data-aos="fade-up" data-aos-delay="400">
                                <a href="#" class="icon-text">
                                    <GoGraph />
                                </a>
                                <h3>Seamless Fleet Management</h3>
                                <p class="paragraph">
                                    <strong>Integrated Technology:</strong> Manage schedules, routes, and energy consumption effortlessly with our smart fleet systems.
                                </p>
                                <p class="paragraph">
                                    <strong>Real-Time Insights:</strong> Stay informed with live data on vehicle performance, battery status, and delivery metrics for better decision-making.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div class="info-card" data-aos="fade-up" data-aos-delay="500">
                                <a href="#" class="icon-text">
                                    <IoMdMail />
                                </a>
                                <h3>Commitment to Sustainability </h3>
                                <p class="paragraph">
                                    <strong>Be a Green Pioneer:</strong> Partner with I-Line to lead the shift toward zero-emission logistics, enhancing your brand’s reputation and environmental impact.
                                </p>
                                <p class="paragraph">
                                    <strong>Supportive Network:</strong> Leverage our ecosystem for long-term success, from leasing to battery management and maintenance support.
                                </p>
                            </div>
                        </div>



                    </div>
                </div>
            </section>
            {/* 
             */}
            <Footer />
        </>
    )
}

export default WhyChoose;